import {AnyAction, Dispatch} from 'redux';
import {connect} from 'react-redux';
import AlertComponent from '../../../../common/components/alert/AlertComponent';
import {State} from '../../../types/mx/reducers';
import {AlertProps} from '../../../../common/types/components';
import * as AlertActions from '../../../../common/actions/AlertActions';
import {AlertDispatchProps} from '../../../types/mx/creditoReal/containers';

const mapStateToProps = (state: State): Partial<AlertProps> => ({
    alertList: state.ui.alert.alertList
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): AlertDispatchProps => ({
    removeAlert: (key: string) => dispatch(AlertActions.REMOVE_ALERT_ACTION.action(key))
});

const AlertContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertComponent);

export default AlertContainer;